<template>
  <zm-modal @ok="handleSubmit" :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="22">
            <a-form-item>
              <a-alert message="确认忽略本次考核？" type="warning" show-icon />
            </a-form-item>
          </a-col>
          <a-col :sapn="22">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" hasFeedback>
              <a-textarea
                placeholder="请输入忽略本次考核的原因"
                :auto-size="{ minRows: 3, maxRows: 3 }"
                v-decorator="['remark', { rules: [{ required: true, message: '请输入忽略本次考核的原因' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-modal>
</template>

<script>
import { DeleteUserEvaluateOne } from '@/api/assessment'
export default {
  name: 'importAssessment',
  mounted() {},
  computed: {},
  data() {
    return {
      title: '操作',
      width: 600,
      form: this.$form.createForm(this, { name: 'assessment' }),
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 21 },
      },
    }
  },
  methods: {
    // 设置标题
    setTitle(title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      this.formClear()
      this.visible = flag
    },
    // 提交表单
    handleSubmit() {
      this.form.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const params = { ...value}
          params.id = this.model.id
          DeleteUserEvaluateOne(params).then((res) => {
            if (res.status === 0) {
              this.$message.success('提交成功')
              this.$emit('refreshTable')
              this.open(false) // 提交成功关闭弹框
              this.formClear() // 关闭弹框后清除表单
            }
          })
        }
      })
    },
    // 清空表单
    formClear() {
      this.form.resetFields()
    },
    cancel() {
      this.formClear()
      this.open(false)
    },
    // 获取select列表
  },
}
</script>

<style scoped>
::v-deep .ant-alert-warning {
  background-color: white;
  border: 1px solid white;
}
</style>

